import { throwException, blobToText } from '../common';
import type { ListPaginatedDTO } from '@pct-sdk/core';
import type { HttpContext } from '@angular/common/http';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import type {
  ForbiddenNicknameGetDTO,
  ForbiddenNicknameOrderByColumn,
  ForbiddenNicknamePostDTO,
  OrderByDirection,
  PaginatedDTOOfForbiddenNicknameGetDTO,
} from '../dto/dto';

import { environment } from '@szte-griffin/environment';
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
// ReSharper disable InconsistentNaming
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import type { Observable } from 'rxjs';
import { throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject } from '@angular/core';

/* eslint-disable */
@Injectable()
export class ForbiddenNicknameService {
  private http: HttpClient;
  private readonly baseUrl = environment.apiUrl;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  constructor(
    @Inject(HttpClient)
    http: HttpClient,
  ) {
    this.http = http;
  }
  /**
   * @param ids (optional)
   * @param searchText (optional)
   * @param orderColumn (optional)
   * @param orderDirection (optional)
   * @param pageNumber (optional)
   * @param pageSize (optional)
   * @return OK
   */
  public listForbiddenNicknames(
    ids?: string[] | undefined,
    searchText?: string | undefined,
    orderColumn?: ForbiddenNicknameOrderByColumn | undefined,
    orderDirection?: OrderByDirection | undefined,
    pageNumber?: number | undefined,
    pageSize?: number | undefined,
    httpContext?: HttpContext,
  ): Observable<ListPaginatedDTO<ForbiddenNicknameGetDTO>> {
    let url_ = this.baseUrl + '/admin/forbidden-nicknames?';
    if (ids === null) throw new Error("The parameter 'ids' cannot be null.");
    else if (ids !== undefined)
      ids &&
        ids.forEach(item => {
          url_ += 'ids=' + encodeURIComponent('' + item) + '&';
        });
    if (searchText === null) throw new Error("The parameter 'searchText' cannot be null.");
    else if (searchText !== undefined)
      url_ += 'searchText=' + encodeURIComponent('' + searchText) + '&';
    if (orderColumn === null) throw new Error("The parameter 'orderColumn' cannot be null.");
    else if (orderColumn !== undefined)
      url_ += 'orderColumn=' + encodeURIComponent('' + orderColumn) + '&';
    if (orderDirection === null) throw new Error("The parameter 'orderDirection' cannot be null.");
    else if (orderDirection !== undefined)
      url_ += 'orderDirection=' + encodeURIComponent('' + orderDirection) + '&';
    if (pageNumber === null) throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += 'pageNumber=' + encodeURIComponent('' + pageNumber) + '&';
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += 'pageSize=' + encodeURIComponent('' + pageSize) + '&';
    url_ = url_.replace(/[?&]$/, '');
    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
      context: httpContext,
    };
    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListForbiddenNicknames(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListForbiddenNicknames(response_ as any);
            } catch (e) {
              return _observableThrow(
                e,
              ) as any as Observable<PaginatedDTOOfForbiddenNicknameGetDTO>;
            }
          } else
            return _observableThrow(
              response_,
            ) as any as Observable<PaginatedDTOOfForbiddenNicknameGetDTO>;
        }),
      );
  }
  protected processListForbiddenNicknames(
    response: HttpResponseBase,
  ): Observable<ListPaginatedDTO<ForbiddenNicknameGetDTO>> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver,
                ) as PaginatedDTOOfForbiddenNicknameGetDTO);
          return _observableOf(result200);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>OUT_OF_RANGE_PAGE_SIZE - The page size must be more than zero.</li><li>TOO_LONG_SEARCH_TEXT - The search text is too long.</li><li>TOO_SMALL_PAGE_NUMBER - The page number must be more than zero.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @param body (optional)
   * @return Created
   */
  public createForbiddenNickname(
    body?: ForbiddenNicknamePostDTO | undefined,
    httpContext?: HttpContext,
  ): Observable<ForbiddenNicknameGetDTO> {
    let url_ = this.baseUrl + '/admin/forbidden-nicknames';
    url_ = url_.replace(/[?&]$/, '');
    const content_ = JSON.stringify(body);
    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
      context: httpContext,
    };
    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateForbiddenNickname(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreateForbiddenNickname(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ForbiddenNicknameGetDTO>;
            }
          } else return _observableThrow(response_) as any as Observable<ForbiddenNicknameGetDTO>;
        }),
      );
  }
  protected processCreateForbiddenNickname(
    response: HttpResponseBase,
  ): Observable<ForbiddenNicknameGetDTO> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          result201 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ForbiddenNicknameGetDTO);
          return _observableOf(result201);
        }),
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>REQUIRED_NICKNAME - Nickname is required.</li><li>TOO_LONG_NICKNAME - Nickname is too long.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status === 409) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            '<ul><li>TAKEN_FORBIDDEN_NICKNAME_VALUE - There is already a forbidden nickname with the given value.</li></ul>',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
  /**
   * @return No Content
   */
  public deleteForbiddenNickname(id: string, httpContext?: HttpContext): Observable<void> {
    let url_ = this.baseUrl + '/admin/forbidden-nicknames/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');
    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      withCredentials: true,
      headers: new HttpHeaders({}),
      context: httpContext,
    };
    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteForbiddenNickname(response_);
        }),
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDeleteForbiddenNickname(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        }),
      );
  }
  protected processDeleteForbiddenNickname(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
          ? (response as any).error
          : undefined;
    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        }),
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'Endpoint is available only after logging in.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers,
          );
        }),
      );
    }
    return _observableOf(null as any);
  }
}
